import InputContainer, { InputContainerProps } from './InputContainer';

export default InputContainer;
export type { InputContainerProps };
